<template>

  <SideBarAsideUser/>

  <div class="content pd-0" style="border: 1px solid #ccc;">

    <div class="content-body">
      <div class="container pd-x-0">

        <!-- ══ MAIN LAYOUT ══ -->
        <main class="sf-layout" style="margin-top: -25px;">

          <!-- ── LEFT SIDEBAR ── -->
          <aside class="sf-sidebar">
            <!-- Profile card -->
            <div class="sf-profile-card">
              <div class="sf-profile-banner"></div>
              <div class="sf-profile-avatar av1">SJ</div>
              <h4>Sarah Johnson</h4>
              <p style="font-size:12px;color:#666;margin:4px 12px 8px;">Senior Product Designer at Anthropic</p>
              <hr class="sf-profile-divider">
              <div class="sf-profile-stat">
                <span>Profile viewers</span>
                <span>124</span>
              </div>
              <div class="sf-profile-stat">
                <span>Post impressions</span>
                <span>1,842</span>
              </div>
              <hr class="sf-profile-divider">
              <div style="padding:4px 16px 0;">
                <a href="#" style="font-size:12px;font-weight:600;color:#666;text-decoration:none;display:flex;align-items:center;gap:6px;">
                  <i class="fas fa-bookmark" style="color:#0a66c2;"></i> My Items
                </a>
              </div>
            </div>

            <!-- Navigation -->
            <div class="sf-card sf-sidebar-nav">
              <a href="#" class="sf-sidebar-link active">
                <i class="fas fa-home"></i> Feed
              </a>
              <a href="#" class="sf-sidebar-link">
                <i class="fas fa-user-friends"></i> Connections
              </a>
              <a href="#" class="sf-sidebar-link">
                <i class="fas fa-layer-group"></i> Groups
              </a>
              <a href="#" class="sf-sidebar-link">
                <i class="fas fa-calendar-alt"></i> Events
              </a>
              <a href="#" class="sf-sidebar-link">
                <i class="fas fa-newspaper"></i> Newsletters
              </a>
              <hr class="sf-profile-divider" style="margin:4px 0;">
              <div class="sf-sidebar-section-title">Recent</div>
              <a href="#" class="sf-recent-item"><i class="fas fa-clock"></i> AI & Machine Learning</a>
              <a href="#" class="sf-recent-item"><i class="fas fa-clock"></i> Product Design</a>
              <a href="#" class="sf-recent-item"><i class="fas fa-clock"></i> Tech Startups</a>
              <hr class="sf-profile-divider" style="margin:4px 0;">
              <a href="#" class="sf-sidebar-link">
                <i class="fas fa-store"></i> Marketplace
              </a>
              <a href="#" class="sf-sidebar-link" style="color:#666;font-size:12px;">
                <i class="fas fa-ellipsis-h" style="font-size:14px;"></i> Discover more
              </a>
            </div>

            <!-- Ad widget -->
            <div class="sf-card" style="padding:14px;">
              <div style="font-size:11px;color:#999;text-align:right;margin-bottom:6px;">Ad</div>
              <div style="display:flex;gap:8px;align-items:flex-start;margin-bottom:8px;">
                <div style="width:40px;height:40px;border-radius:4px;background:linear-gradient(135deg,#0a66c2,#0d8ecf);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:900;font-size:14px;flex-shrink:0;">in</div>
                <div>
                  <div style="font-size:13px;font-weight:600;">Grow with LinkedIn</div>
                  <div style="font-size:11px;color:#666;">Reach your goals faster</div>
                </div>
              </div>
              <button class="sf-ad-btn" style="display:flex;align-items:center;justify-content:center;gap:6px;width:100%;"><i class="fas fa-rocket"></i> Get started</button>
            </div>
          </aside>

          <!-- ── FEED CENTER ── -->
          <section class="sf-feed">

            <!-- Create Post -->
            <div class="sf-create-post">
              <div class="sf-create-row">
                <div class="sf-avatar-sm av1">SJ</div>
                <input class="sf-post-input" type="text" placeholder="Start a post, try writing with AI">
              </div>
              <div class="sf-create-actions">
                <button class="sf-action-btn photo"><i class="fas fa-image"></i> Photo</button>
                <button class="sf-action-btn video"><i class="fas fa-video"></i> Video</button>
                <button class="sf-action-btn event"><i class="fas fa-calendar-plus"></i> Event</button>
                <button class="sf-action-btn article"><i class="fas fa-pencil-alt"></i> Write article</button>
              </div>
            </div>

            <!-- Sort bar -->
            <div style="display:flex;align-items:center;gap:8px;padding:0 4px;">
              <div style="flex:1;height:1px;background:var(--df-border);"></div>
              <span style="font-size:13px;font-weight:700;color:#666;white-space:nowrap;display:flex;align-items:center;gap:6px;cursor:pointer;">
        Sort by: <span style="color:#191919;">Top</span> <i class="fas fa-caret-down" style="color:#191919;"></i>
      </span>
            </div>

            <!-- ── POST 1 – Text + Image ── -->
            <div class="sf-post">
              <div class="sf-post-header">
                <div class="sf-post-avatar" :class="feedPosts[0].user.avatar">{{ feedPosts[0].user.initials }}</div>
                <div class="sf-post-meta">
                  <h4>{{ feedPosts[0].user.name }}</h4>
                  <div class="headline">{{ feedPosts[0].user.headline }}</div>
                  <div class="time"><i class="fas fa-globe-americas" style="font-size:10px;"></i> {{ feedPosts[0].user.time }}</div>
                </div>
                <div class="sf-post-options">
                  <button v-if="!feedPosts[0].user.following" class="sf-follow-btn"><i class="fas fa-plus" style="font-size:12px;"></i> Follow</button>
                  <button><i class="fas fa-ellipsis-h"></i></button>
                  <button><i class="fas fa-times"></i></button>
                </div>
              </div>
              <div class="sf-post-body" v-html="feedPosts[0].body"></div>
              <div class="sf-post-img-placeholder" :class="feedPosts[0].media.className" :style="feedPosts[0].media.style || ''" v-if="feedPosts[0].media">
                {{ feedPosts[0].media.content }}
              </div>
              <div class="sf-post-stats">
                <div class="sf-reactions">
                  <span v-for="emoji in feedPosts[0].reactions.emojis" :key="emoji" class="sf-reaction-emoji">{{ emoji }}</span>
                  <span class="sf-reactions-text">{{ feedPosts[0].reactions.text }}</span>
                </div>
                <div v-html="feedPosts[0].engagement"></div>
              </div>
              <hr class="sf-post-divider">
              <div class="sf-post-actions">
                <button class="sf-post-action" :class="{ liked: feedPosts[0].liked }"><i class="fas fa-thumbs-up"></i> Like</button>
                <button class="sf-post-action"><i class="fas fa-comment"></i> Comment</button>
                <button class="sf-post-action"><i class="fas fa-retweet"></i> Repost</button>
                <button class="sf-post-action"><i class="fas fa-paper-plane"></i> Send</button>
              </div>
              <div class="sf-comment-section">
                <div v-if="feedPosts[0].hasLoadMore" class="sf-load-more-comments"><i class="fas fa-chevron-down"></i> {{ feedPosts[0].loadMoreText }}</div>
                <template v-for="(comment, cIndex) in feedPosts[0].sampleComments" :key="`c-${cIndex}`">
                  <div class="sf-comment" :style="comment.marginTop ? 'margin-top:8px;' : ''">
                    <div class="sf-comment-avatar" :class="comment.avatar">{{ comment.initials }}</div>
                    <div class="sf-comment-bubble">
                      <div class="author">{{ comment.author }}</div>
                      <div class="text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div class="sf-comment-actions">
                    <span>Like</span><span>Reply</span><span style="color:#999;font-weight:400;">{{ comment.time }}</span>
                  </div>
                </template>
                <div class="sf-comment-input-row" style="margin-top:10px;">
                  <div class="sf-avatar-sm av1" style="width:32px;height:32px;font-size:11px;">SJ</div>
                  <input class="sf-comment-input" type="text" placeholder="Add a comment…">
                </div>
              </div>
            </div>

            <!-- ── POST 2 – Text only ── -->
            <div class="sf-post">
              <div class="sf-post-header">
                <div class="sf-post-avatar" :class="feedPosts[1].user.avatar">{{ feedPosts[1].user.initials }}</div>
                <div class="sf-post-meta">
                  <h4>{{ feedPosts[1].user.name }}</h4>
                  <div class="headline">{{ feedPosts[1].user.headline }}</div>
                  <div class="time"><i class="fas fa-globe-americas" style="font-size:10px;"></i> {{ feedPosts[1].user.time }}</div>
                </div>
                <div class="sf-post-options">
                  <button v-if="!feedPosts[1].user.following" class="sf-follow-btn"><i class="fas fa-plus" style="font-size:12px;"></i> Follow</button>
                  <button><i class="fas fa-ellipsis-h"></i></button>
                  <button><i class="fas fa-times"></i></button>
                </div>
              </div>
              <div class="sf-post-body" v-html="feedPosts[1].body"></div>
              <div class="sf-post-img-placeholder" :class="feedPosts[1].media.className" :style="feedPosts[1].media.style || ''" v-if="feedPosts[1].media">
                {{ feedPosts[1].media.content }}
              </div>
              <div class="sf-post-stats">
                <div class="sf-reactions">
                  <span v-for="emoji in feedPosts[1].reactions.emojis" :key="emoji" class="sf-reaction-emoji">{{ emoji }}</span>
                  <span class="sf-reactions-text">{{ feedPosts[1].reactions.text }}</span>
                </div>
                <div v-html="feedPosts[1].engagement"></div>
              </div>
              <hr class="sf-post-divider">
              <div class="sf-post-actions">
                <button class="sf-post-action" :class="{ liked: feedPosts[1].liked }"><i class="fas fa-thumbs-up"></i> Like</button>
                <button class="sf-post-action"><i class="fas fa-comment"></i> Comment</button>
                <button class="sf-post-action"><i class="fas fa-retweet"></i> Repost</button>
                <button class="sf-post-action"><i class="fas fa-paper-plane"></i> Send</button>
              </div>
              <div class="sf-comment-section">
                <div v-if="feedPosts[1].hasLoadMore" class="sf-load-more-comments"><i class="fas fa-chevron-down"></i> {{ feedPosts[1].loadMoreText }}</div>
                <template v-for="(comment, cIndex) in feedPosts[1].sampleComments" :key="`c-${cIndex}`">
                  <div class="sf-comment" :style="comment.marginTop ? 'margin-top:8px;' : ''">
                    <div class="sf-comment-avatar" :class="comment.avatar">{{ comment.initials }}</div>
                    <div class="sf-comment-bubble">
                      <div class="author">{{ comment.author }}</div>
                      <div class="text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div class="sf-comment-actions">
                    <span>Like</span><span>Reply</span><span style="color:#999;font-weight:400;">{{ comment.time }}</span>
                  </div>
                </template>
                <div class="sf-comment-input-row" style="margin-top:10px;">
                  <div class="sf-avatar-sm av1" style="width:32px;height:32px;font-size:11px;">SJ</div>
                  <input class="sf-comment-input" type="text" placeholder="Add a comment…">
                </div>
              </div>
            </div>

            <!-- ── PEOPLE YOU MAY KNOW (in-feed) ── -->
            <div class="sf-card" style="padding:16px;">
              <div style="font-size:14px;font-weight:700;margin-bottom:12px;display:flex;justify-content:space-between;align-items:center;">
                People you may know <a href="#" style="font-size:12px;color:#666;font-weight:400;text-decoration:none;">See all</a>
              </div>
              <div style="display:flex;gap:8px;overflow-x:auto;padding-bottom:4px;">
                <div v-for="(person, index) in suggestedPeople" :key="index" style="flex:0 0 150px;border:1px solid var(--df-border);border-radius:8px;overflow:hidden;text-align:center;padding-bottom:12px;">
                  <div :style="{ height: '48px', background: person.banner }"></div>
                  <div class="sf-post-avatar" :class="person.avatar" style="width:52px;height:52px;font-size:15px;margin:-26px auto 6px;border:3px solid #fff;">{{ person.initials }}</div>
                  <div style="font-size:13px;font-weight:600;padding:0 8px;">{{ person.name }}</div>
                  <div style="font-size:11px;color:#666;padding:0 8px;line-height:1.3;margin-bottom:8px;">{{ person.subtitle }}</div>
                  <button class="sf-connect-btn">+ Connect</button>
                </div>
              </div>
            </div>

            <!-- ── POST 3 – Image post ── -->
            <div class="sf-post">
              <div class="sf-post-header">
                <div class="sf-post-avatar" :class="feedPosts[2].user.avatar">{{ feedPosts[2].user.initials }}</div>
                <div class="sf-post-meta">
                  <h4>{{ feedPosts[2].user.name }}</h4>
                  <div class="headline">{{ feedPosts[2].user.headline }}</div>
                  <div class="time"><i class="fas fa-globe-americas" style="font-size:10px;"></i> {{ feedPosts[2].user.time }}</div>
                </div>
                <div class="sf-post-options">
                  <button v-if="!feedPosts[2].user.following" class="sf-follow-btn"><i class="fas fa-plus" style="font-size:12px;"></i> Follow</button>
                  <button><i class="fas fa-ellipsis-h"></i></button>
                  <button><i class="fas fa-times"></i></button>
                </div>
              </div>
              <div class="sf-post-body" v-html="feedPosts[2].body"></div>
              <div class="sf-post-img-placeholder" :class="feedPosts[2].media.className" :style="feedPosts[2].media.style || ''" v-if="feedPosts[2].media">
                {{ feedPosts[2].media.content }}
              </div>
              <div class="sf-post-stats">
                <div class="sf-reactions">
                  <span v-for="emoji in feedPosts[2].reactions.emojis" :key="emoji" class="sf-reaction-emoji">{{ emoji }}</span>
                  <span class="sf-reactions-text">{{ feedPosts[2].reactions.text }}</span>
                </div>
                <div v-html="feedPosts[2].engagement"></div>
              </div>
              <hr class="sf-post-divider">
              <div class="sf-post-actions">
                <button class="sf-post-action" :class="{ liked: feedPosts[2].liked }"><i class="fas fa-thumbs-up"></i> Like</button>
                <button class="sf-post-action"><i class="fas fa-comment"></i> Comment</button>
                <button class="sf-post-action"><i class="fas fa-retweet"></i> Repost</button>
                <button class="sf-post-action"><i class="fas fa-paper-plane"></i> Send</button>
              </div>
              <div class="sf-comment-section">
                <div v-if="feedPosts[2].hasLoadMore" class="sf-load-more-comments"><i class="fas fa-chevron-down"></i> {{ feedPosts[2].loadMoreText }}</div>
                <template v-for="(comment, cIndex) in feedPosts[2].sampleComments" :key="`c-${cIndex}`">
                  <div class="sf-comment" :style="comment.marginTop ? 'margin-top:8px;' : ''">
                    <div class="sf-comment-avatar" :class="comment.avatar">{{ comment.initials }}</div>
                    <div class="sf-comment-bubble">
                      <div class="author">{{ comment.author }}</div>
                      <div class="text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div class="sf-comment-actions">
                    <span>Like</span><span>Reply</span><span style="color:#999;font-weight:400;">{{ comment.time }}</span>
                  </div>
                </template>
                <div class="sf-comment-input-row" style="margin-top:10px;">
                  <div class="sf-avatar-sm av1" style="width:32px;height:32px;font-size:11px;">SJ</div>
                  <input class="sf-comment-input" type="text" placeholder="Add a comment…">
                </div>
              </div>
            </div>

            <!-- ── POST 4 – Article share ── -->
            <div class="sf-post">
              <div class="sf-post-header">
                <div class="sf-post-avatar" :class="feedPosts[3].user.avatar">{{ feedPosts[3].user.initials }}</div>
                <div class="sf-post-meta">
                  <h4>{{ feedPosts[3].user.name }}</h4>
                  <div class="headline">{{ feedPosts[3].user.headline }}</div>
                  <div class="time"><i class="fas fa-globe-americas" style="font-size:10px;"></i> {{ feedPosts[3].user.time }}</div>
                </div>
                <div class="sf-post-options">
                  <button v-if="!feedPosts[3].user.following" class="sf-follow-btn"><i class="fas fa-plus" style="font-size:12px;"></i> Follow</button>
                  <button><i class="fas fa-ellipsis-h"></i></button>
                  <button><i class="fas fa-times"></i></button>
                </div>
              </div>
              <div class="sf-post-body" v-html="feedPosts[3].body"></div>
              <div v-if="feedPosts[3].media && feedPosts[3].media.type === 'article'" :style="feedPosts[3].media.preview.style" onmouseover="this.style.boxShadow='0 2px 8px rgba(0,0,0,0.1)'" onmouseout="this.style.boxShadow='none'">
                <div :class="feedPosts[3].media.preview.img.class" :style="feedPosts[3].media.preview.img.style">{{ feedPosts[3].media.preview.img.content }}</div>
                <div style="padding:12px;">
                  <div :style="feedPosts[3].media.preview.domainStyle">{{ feedPosts[3].media.preview.domain }}</div>
                  <div :style="feedPosts[3].media.preview.titleStyle">{{ feedPosts[3].media.preview.title }}</div>
                  <div :style="feedPosts[3].media.preview.descStyle">{{ feedPosts[3].media.preview.desc }}</div>
                </div>
              </div>
              <div class="sf-post-stats">
                <div class="sf-reactions">
                  <span v-for="emoji in feedPosts[3].reactions.emojis" :key="emoji" class="sf-reaction-emoji">{{ emoji }}</span>
                  <span class="sf-reactions-text">{{ feedPosts[3].reactions.text }}</span>
                </div>
                <div v-html="feedPosts[3].engagement"></div>
              </div>
              <hr class="sf-post-divider">
              <div class="sf-post-actions">
                <button class="sf-post-action" :class="{ liked: feedPosts[3].liked }"><i class="fas fa-thumbs-up"></i> Like</button>
                <button class="sf-post-action"><i class="fas fa-comment"></i> Comment</button>
                <button class="sf-post-action"><i class="fas fa-retweet"></i> Repost</button>
                <button class="sf-post-action"><i class="fas fa-paper-plane"></i> Send</button>
              </div>
              <div class="sf-comment-section">
                <div v-if="feedPosts[3].hasLoadMore" class="sf-load-more-comments"><i class="fas fa-chevron-down"></i> {{ feedPosts[3].loadMoreText }}</div>
                <template v-for="(comment, cIndex) in feedPosts[3].sampleComments" :key="`c-${cIndex}`">
                  <div class="sf-comment" :style="comment.marginTop ? 'margin-top:8px;' : ''">
                    <div class="sf-comment-avatar" :class="comment.avatar">{{ comment.initials }}</div>
                    <div class="sf-comment-bubble">
                      <div class="author">{{ comment.author }}</div>
                      <div class="text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div class="sf-comment-actions">
                    <span>Like</span><span>Reply</span><span style="color:#999;font-weight:400;">{{ comment.time }}</span>
                  </div>
                </template>
                <div class="sf-comment-input-row" style="margin-top:10px;">
                  <div class="sf-avatar-sm av1" style="width:32px;height:32px;font-size:11px;">SJ</div>
                  <input class="sf-comment-input" type="text" placeholder="Add a comment…">
                </div>
              </div>
            </div>

          </section>

          <!-- ── RIGHT SIDEBAR ── -->
          <aside class="sf-right">

            <!-- LinkedIn News -->
            <div class="sf-widget">
              <div class="sf-widget-title">
                LinkedIn News <i class="fas fa-info-circle" style="color:#999;font-size:14px;cursor:pointer;"></i>
              </div>
              <div class="sf-news-list">
                <div class="sf-news-item">
                  <h5>AI startups raise $12B in Q1 2025</h5>
                  <p>Top story · 48,291 readers</p>
                </div>
                <div class="sf-news-item">
                  <h5>Design systems are reshaping product teams</h5>
                  <p>5h ago · 12,400 readers</p>
                </div>
                <div class="sf-news-item">
                  <h5>Remote work policies see major shift</h5>
                  <p>3h ago · 29,100 readers</p>
                </div>
                <div class="sf-news-item">
                  <h5>The rise of developer experience roles</h5>
                  <p>8h ago · 7,820 readers</p>
                </div>
                <div class="sf-news-item">
                  <h5>Open source LLMs close gap with GPT-4</h5>
                  <p>1d ago · 54,000 readers</p>
                </div>
              </div>
              <div style="margin-top:12px;font-size:13px;font-weight:600;color:#666;cursor:pointer;display:flex;align-items:center;gap:4px;">
                Show more <i class="fas fa-chevron-down" style="font-size:11px;"></i>
              </div>
            </div>

            <!-- People you may know -->
            <div class="sf-widget">
              <div class="sf-widget-title">
                People you may know <a href="#">See all</a>
              </div>
              <div class="sf-people-list">
                <div class="sf-person">
                  <div class="sf-person-avatar av2">MR</div>
                  <div class="sf-person-info">
                    <h5>Marcus Rivera</h5>
                    <p>Head of Engineering</p>
                  </div>
                  <button class="sf-connect-btn">Connect</button>
                </div>
                <div class="sf-person">
                  <div class="sf-person-avatar av4">NP</div>
                  <div class="sf-person-info">
                    <h5>Noah Park</h5>
                    <p>Startup Founder · YC</p>
                  </div>
                  <button class="sf-connect-btn">Connect</button>
                </div>
                <div class="sf-person">
                  <div class="sf-person-avatar av5">RC</div>
                  <div class="sf-person-info">
                    <h5>Rachel Chen</h5>
                    <p>Product Manager</p>
                  </div>
                  <button class="sf-connect-btn">Connect</button>
                </div>
                <div class="sf-person">
                  <div class="sf-person-avatar av3">LM</div>
                  <div class="sf-person-info">
                    <h5>Lena Martinez</h5>
                    <p>UX Lead · Google</p>
                  </div>
                  <button class="sf-connect-btn">Connect</button>
                </div>
              </div>
            </div>

            <!-- Ad -->
            <div class="sf-ad-card">
              <div class="sf-ad-img"><i class="fas fa-crown" style="font-size:32px;opacity:0.8;"></i></div>
              <div class="sf-ad-body">
                <div style="font-size:11px;color:#999;margin-bottom:4px;">Promoted</div>
                <h5>Stand out with LinkedIn Premium</h5>
                <p>Get AI-powered insights, InMail credits, and see who viewed your profile.</p>
                <a href="#" class="sf-ad-btn"><i class="fas fa-star" style="color:gold;"></i> Try free for 1 month</a>
              </div>
            </div>

            <!-- Footer -->
            <div style="padding:0 4px;">
              <div class="sf-footer-links">
                <a href="#">About</a>
                <a href="#">Accessibility</a>
                <a href="#">Help Center</a>
                <a href="#">Privacy & Terms</a>
                <a href="#">Ad Choices</a>
                <a href="#">Advertising</a>
                <a href="#">Business Services</a>
                <a href="#">More</a>
              </div>
              <div class="sf-footer-brand">LinkedIn Corporation © 2025</div>
            </div>

          </aside>

        </main>








      </div><!-- container -->

    </div>

  </div>


</template>

<script>

import visualizationMixin from "@/mixins/visualization-script";
import footerScriptMixin from "@/mixins/footer-script";
import serviceMixin from "@/mixins/contact-service";
import SideBarAsideUser from "../components/SideBarAsideUser.vue";

export default {
  name: 'UserFeed2',
  components: {SideBarAsideUser},
  mixins: [visualizationMixin, footerScriptMixin, serviceMixin],
  data() {
    return {
      newPost: '',
      posts: [
        {
          id: 1,
          user: {
            name: 'Abayomi Ayodele',
            avatar: 'https://via.placeholder.com/40?text=AA'
          },
          time: '2h ago',
          content: 'Just had a great day at church! Loving the community here. #Blessed',
          image: 'https://via.placeholder.com/500x300',
          liked: false,
          likes: 23,
          comments: [
            { id: 1, user: 'John Doe', text: 'Amen!' },
            { id: 2, user: 'Jane Smith', text: 'Looks fun!' }
          ]
        },
        {
          id: 2,
          user: {
            name: 'Pastor Mark',
            avatar: 'https://via.placeholder.com/40?text=PM'
          },
          time: '1d ago',
          content: 'Join us for bible study this week.',
          image: null,
          liked: true,
          likes: 156,
          comments: [
            { id: 3, user: 'Sarah', text: "I'll be there!" }
          ]
        }
      ],
      feedPosts: [
        {
          id: 1,
          user: {
            avatar: "av2",
            initials: "MR",
            name: "Marcus Rivera",
            headline: "Head of Engineering · Joined 3rd",
            time: "2h",
            public: true,
            following: false
          },
          body: `Excited to share that we just shipped a major update to our design system 🎉<br><br>
After 6 months of work, we've unified our component library across 4 products, reduced our bundle size by 40%, and improved accessibility scores to 98/100.<br><br>
The biggest lesson? Consistency beats customization every time. <span class="read-more">...more</span>`,
          media: {
            type: "image",
            className: "post-img-1",
            content: "🚀"
          },
          reactions: {
            emojis: ["👍", "❤️", "💡"],
            text: "Priya, Alex and 847 others"
          },
          engagement: "142 comments · 38 reposts",
          liked: true,
          hasLoadMore: true,
          loadMoreText: "View 98 more comments",
          sampleComments: [
            {
              avatar: "av3",
              initials: "PS",
              author: "Priya Singh",
              text: "This is huge! Congrats to the team 🙌 The accessibility improvements alone are worth celebrating.",
              time: "1h"
            },
            {
              avatar: "av4",
              initials: "JL",
              author: "James Liu",
              text: "40% bundle reduction is impressive! Would love to hear more about the tooling you used.",
              time: "45m",
              marginTop: true
            }
          ]
        },
        {
          id: 2,
          user: {
            avatar: "av5",
            initials: "AK",
            name: "Aisha Khan",
            headline: "AI Research Scientist · 1st",
            time: "5h",
            public: true,
            following: false
          },
          body: `Hot take: The best AI products aren't the ones with the most parameters — they're the ones with the clearest problem definition.<br><br>
I've reviewed 200+ AI product pitches this year. The ones that fail share one trait: they start with the model, not the user need.<br><br>
Start with "what does the user struggle with?" not "what can we do with GPT-4?"<br><br>
Agree or disagree? 👇 <span class="read-more">...more</span>`,
          media: null,
          reactions: {
            emojis: ["💡", "❤️", "👍"],
            text: "2,341 reactions"
          },
          engagement: "318 comments · 91 reposts",
          liked: false,
          hasLoadMore: false,
          sampleComments: [
            {
              avatar: "av6",
              initials: "TO",
              author: "Tom O'Brien",
              text: "100% agree. Most AI demos I see are solutions looking for problems. The user-first framing changes everything.",
              time: "3h"
            }
          ]
        },
        {
          id: 3,
          user: {
            avatar: "av6",
            initials: "ZO",
            name: "Zoe Okonkwo",
            headline: "Design Director at Figma · 2nd",
            time: "8h",
            public: true,
            following: true
          },
          body: `Just wrapped up our annual design retreat in Lisbon 🇵🇹<br>
3 days, 40 designers, 12 workshops, and one shared vision. The energy was electric ✨`,
          media: {
            type: "image",
            className: "post-img-2",
            style: "height:240px;",
            content: "🌊"
          },
          reactions: {
            emojis: ["❤️", "👍", "🎉"],
            text: "1,204 reactions"
          },
          engagement: "87 comments · 24 reposts",
          liked: false,
          hasLoadMore: false,
          sampleComments: [
            {
              avatar: "av2",
              initials: "MR",
              author: "Marcus Rivera",
              text: "This looks absolutely amazing! Figma design retreats are legendary 🔥",
              time: "6h"
            }
          ]
        },
        {
          id: 4,
          user: {
            avatar: "av3",
            initials: "BT",
            name: "Ben Thompson",
            headline: "Senior Software Engineer · 1st",
            time: "1d",
            public: true,
            following: false
          },
          body: `The future of frontend development is here. React Server Components + Streaming SSR = insane performance gains 🚀<br><br>
Been running benchmarks for a month. Here are the results:`,
          media: {
            type: "article",
            preview: {
              style: "border:1px solid var(--df-border);margin:0 16px 12px;border-radius:4px;overflow:hidden;cursor:pointer;",
              img: {
                class: "post-img-3",
                style: "height:160px;display:flex;align-items:center;justify-content:center;font-size:48px;",
                content: "⚡"
              },
              domainStyle: "font-size:11px;color:#999;margin-bottom:4px;",
              domain: "medium.com",
              titleStyle: "font-size:14px;font-weight:700;line-height:1.3;",
              title: "React Server Components: A Deep Dive into Performance",
              descStyle: "font-size:12px;color:#666;margin-top:4px;",
              desc: "How RSC + streaming SSR reduced our TTFB by 60% in production."
            }
          },
          reactions: {
            emojis: ["💡", "👍"],
            text: "567 reactions"
          },
          engagement: "43 comments",
          liked: false,
          hasLoadMore: false,
          sampleComments: []
        }
      ],
      suggestedPeople: [
        {
          banner: "linear-gradient(135deg,#4facfe,#00f2fe)",
          avatar: "av3",
          initials: "LM",
          name: "Lena Martinez",
          subtitle: "UX Lead · Google"
        },
        {
          banner: "linear-gradient(135deg,#43e97b,#38f9d7)",
          avatar: "av4",
          initials: "NP",
          name: "Noah Park",
          subtitle: "Startup Founder · YC W24"
        },
        {
          banner: "linear-gradient(135deg,#fa709a,#fee140)",
          avatar: "av5",
          initials: "RC",
          name: "Rachel Chen",
          subtitle: "PM · Meta"
        },
        {
          banner: "linear-gradient(135deg,#a18cd1,#fbc2eb)",
          avatar: "av6",
          initials: "DW",
          name: "David Wu",
          subtitle: "VP Engineering"
        }
      ]
    }
  },

  created() {
    this.footerScript();
    this.asideBarScript();
  },
  methods: {
    onPostFocus() {
      this.$refs.postInput.style.borderRadius = '8px';
      this.$refs.postInput.placeholder = "What's on your mind?";
    },
    onPostBlur() {
      this.$refs.postInput.style.borderRadius = '35px';
      this.$refs.postInput.placeholder = 'Start a post, try writing with AI';
    },
    likePost(post) {
      post.liked = !post.liked;
      post.likes += post.liked ? 1 : -1;
    }
  }
}
</script>

<style>
@import 'https://app.wcicambridge.org/cdn/assets/css/dashforge.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';
:root {
  --df-blue: #0a66c2;
  --df-blue-light: #e8f0f9;
  --df-green: #057642;
  --df-border: #e0e0e0;
  --df-bg: #f3f2ef;
  --df-card: #ffffff;
  --df-text: #191919;
  --df-muted: #666666;
  --df-sidebar-width: 225px;
  --df-right-width: 300px;
}

* { box-sizing: border-box; margin: 0; padding: 0; }

body {
  background: var(--df-bg);
  font-family: -apple-system, BlinkMacSystemFont, 'IBM Plex Sans', 'Roboto', sans-serif;
  color: var(--df-text);
  font-size: 14px;
}

/* ── NAVBAR ── */
.sf-navbar {
  background: #fff;
  border-bottom: 1px solid var(--df-border);
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: 52px;
  gap: 8px;
}
.sf-navbar .brand {
  font-size: 26px;
  color: var(--df-blue);
  font-weight: 900;
  letter-spacing: -1px;
  margin-right: 4px;
  flex-shrink: 0;
}
.sf-search {
  display: flex;
  align-items: center;
  background: #eef3f8;
  border-radius: 4px;
  padding: 6px 10px;
  gap: 6px;
  flex: 0 0 260px;
}
.sf-search input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: var(--df-text);
}
.sf-search i { color: var(--df-muted); font-size: 13px; }

.sf-nav-items {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 4px;
}
.sf-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 4px;
  color: var(--df-muted);
  text-decoration: none;
  font-size: 11px;
  position: relative;
  transition: color 0.15s;
  border-bottom: 2px solid transparent;
}
.sf-nav-item:hover { color: var(--df-text); }
.sf-nav-item.active { color: var(--df-text); border-bottom-color: var(--df-text); }
.sf-nav-item i { font-size: 20px; margin-bottom: 2px; }
.sf-nav-item .badge {
  position: absolute;
  top: 2px;
  right: 8px;
  background: #e34a4a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 5px;
  min-width: 16px;
  text-align: center;
}
.sf-nav-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 2px;
}
.sf-nav-divider {
  width: 1px;
  height: 36px;
  background: var(--df-border);
  margin: 0 6px;
}
.btn-premium {
  border: 1px solid #915907;
  color: #915907;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
  margin-left: 4px;
}

/* ── LAYOUT ── */
.sf-layout {
  max-width: 1128px;
  margin: 0 auto;
  padding: 24px 16px;
  display: grid;
  grid-template-columns: var(--df-sidebar-width) 1fr var(--df-right-width);
  gap: 24px;
  align-items: start;
}

/* ── CARD BASE ── */
.sf-card {
  background: var(--df-card);
  border-radius: 8px;
  border: 1px solid var(--df-border);
  overflow: hidden;
}

/* ── LEFT SIDEBAR ── */
.sf-sidebar { display: flex; flex-direction: column; gap: 8px; }

.sf-profile-card {
  background: var(--df-card);
  border-radius: 8px;
  border: 1px solid var(--df-border);
  overflow: hidden;
  text-align: center;
  padding-bottom: 12px;
}
.sf-profile-banner {
  height: 56px;
  background: linear-gradient(135deg, #0a66c2 0%, #0073b1 100%);
}
.sf-profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 3px solid #fff;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 22px;
  margin: -32px auto 8px;
  position: relative;
}
.sf-profile-card h4 { font-size: 14px; font-weight: 600; margin-bottom: 2px; }
.sf-profile-card p { font-size: 12px; color: var(--df-muted); margin: 0 12px; line-height: 1.4; }
.sf-profile-divider { border: none; border-top: 1px solid var(--df-border); margin: 10px 0; }

.sf-profile-stat {
  display: flex;
  justify-content: space-between;
  padding: 4px 16px;
  cursor: pointer;
  font-size: 12px;
  color: var(--df-muted);
}
.sf-profile-stat:hover span:last-child { text-decoration: underline; }
.sf-profile-stat span:last-child { font-weight: 600; color: var(--df-blue); }

.sf-sidebar-nav { padding: 8px 0; }
.sf-sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  color: var(--df-text);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  margin: 0 4px;
  transition: background 0.15s;
}
.sf-sidebar-link:hover { background: #f3f2ef; }
.sf-sidebar-link i { font-size: 18px; color: var(--df-muted); width: 20px; text-align: center; }
.sf-sidebar-link.active i { color: var(--df-blue); }
.sf-sidebar-section-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--df-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 8px 16px 4px;
}
.sf-recent-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 16px;
  font-size: 13px;
  color: var(--df-muted);
  cursor: pointer;
  text-decoration: none;
}
.sf-recent-item:hover { color: var(--df-blue); }
.sf-recent-item i { font-size: 12px; }

/* ── FEED CENTER ── */
.sf-feed { display: flex; flex-direction: column; gap: 8px; }

/* Create Post Card */
.sf-create-post {
  background: var(--df-card);
  border-radius: 8px;
  border: 1px solid var(--df-border);
  padding: 12px 16px;
}
.sf-create-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.sf-avatar-sm {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}
.sf-post-input {
  flex: 1;
  border: 1px solid #c9cdd2;
  border-radius: 35px;
  padding: 10px 16px;
  font-size: 14px;
  color: var(--df-muted);
  cursor: pointer;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}
.sf-post-input:hover { border-color: var(--df-text); }
.sf-create-actions {
  display: flex;
  gap: 4px;
  padding-top: 4px;
}
.sf-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--df-muted);
  border: none;
  background: transparent;
  transition: background 0.15s;
}
.sf-action-btn:hover { background: #f3f2ef; color: var(--df-text); }
.sf-action-btn i { font-size: 16px; }
.sf-action-btn.photo i { color: #378fe9; }
.sf-action-btn.video i { color: #5f9b41; }
.sf-action-btn.event i { color: #c37d16; }
.sf-action-btn.article i { color: #e16745; }

/* Post Card */
.sf-post {
  background: var(--df-card);
  border-radius: 8px;
  border: 1px solid var(--df-border);
}
.sf-post-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 16px 16px 0;
}
.sf-post-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}
.sf-post-meta { flex: 1; }
.sf-post-meta h4 {
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.3;
}
.sf-post-meta h4:hover { color: var(--df-blue); text-decoration: underline; }
.sf-post-meta .headline { font-size: 12px; color: var(--df-muted); line-height: 1.3; }
.sf-post-meta .time {
  font-size: 12px;
  color: var(--df-muted);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 1px;
}
.sf-post-options {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.sf-post-options button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 50%;
  color: var(--df-muted);
  font-size: 18px;
  transition: background 0.15s;
}
.sf-post-options button:hover { background: #f3f2ef; color: var(--df-text); }

.sf-follow-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--df-blue);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 6px;
  border-radius: 4px;
}
.sf-follow-btn:hover { background: var(--df-blue-light); }

.sf-post-body {
  padding: 10px 16px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--df-text);
}
.sf-post-body .read-more { color: var(--df-blue); cursor: pointer; font-weight: 500; }
.sf-post-img {
  width: 100%;
  max-height: 380px;
  object-fit: cover;
  display: block;
}
.sf-post-img-placeholder {
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
}

.sf-post-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  font-size: 13px;
  color: var(--df-muted);
}
.sf-reactions { display: flex; align-items: center; gap: 2px; cursor: pointer; }
.sf-reactions:hover .sf-reactions-text { text-decoration: underline; }
.sf-reaction-emoji { font-size: 16px; margin-left: -2px; }
.sf-reactions-text { margin-left: 4px; font-size: 13px; color: var(--df-muted); }
.sf-comments-count { cursor: pointer; }
.sf-comments-count:hover { text-decoration: underline; }

.sf-post-divider { border: none; border-top: 1px solid var(--df-border); margin: 0 16px; }

.sf-post-actions {
  display: flex;
  padding: 2px 8px;
}
.sf-post-action {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 4px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--df-muted);
  border: none;
  background: transparent;
  transition: background 0.15s;
}
.sf-post-action:hover { background: #f3f2ef; color: var(--df-text); }
.sf-post-action i { font-size: 18px; }
.sf-post-action.liked { color: #0a66c2; }
.sf-post-action.liked i { color: #0a66c2; }

.sf-comment-section { padding: 8px 16px 12px; }
.sf-comment {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}
.sf-comment-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
  color: #fff;
}
.sf-comment-bubble {
  background: #f2f2f2;
  border-radius: 0 8px 8px 8px;
  padding: 8px 12px;
  flex: 1;
}
.sf-comment-bubble .author { font-weight: 600; font-size: 13px; }
.sf-comment-bubble .text { font-size: 13px; color: var(--df-text); margin-top: 2px; line-height: 1.4; }
.sf-comment-actions {
  display: flex;
  gap: 12px;
  margin-top: 4px;
  padding-left: 40px;
}
.sf-comment-actions span {
  font-size: 12px;
  color: var(--df-muted);
  cursor: pointer;
  font-weight: 600;
}
.sf-comment-actions span:hover { color: var(--df-text); }
.sf-load-more-comments {
  font-size: 13px;
  font-weight: 700;
  color: var(--df-muted);
  cursor: pointer;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.sf-load-more-comments:hover { color: var(--df-text); }

.sf-comment-input-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.sf-comment-input {
  flex: 1;
  border: 1px solid #c9cdd2;
  border-radius: 35px;
  padding: 8px 14px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
  background: #fff;
}
.sf-comment-input:focus { border-color: var(--df-blue); }

/* ── RIGHT SIDEBAR ── */
.sf-right { display: flex; flex-direction: column; gap: 8px; }

.sf-widget { background: var(--df-card); border-radius: 8px; border: 1px solid var(--df-border); padding: 16px; }
.sf-widget-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sf-widget-title a { font-size: 12px; font-weight: 400; color: var(--df-muted); text-decoration: none; }
.sf-widget-title a:hover { color: var(--df-text); text-decoration: underline; }

.sf-people-list { display: flex; flex-direction: column; gap: 10px; }
.sf-person {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sf-person-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  color: #fff;
}
.sf-person-info { flex: 1; min-width: 0; }
.sf-person-info h5 { font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sf-person-info p { font-size: 11px; color: var(--df-muted); }
.sf-connect-btn {
  border: 1px solid var(--df-blue);
  color: var(--df-blue);
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s;
}
.sf-connect-btn:hover { background: var(--df-blue-light); }

.sf-news-list { display: flex; flex-direction: column; gap: 10px; }
.sf-news-item { cursor: pointer; }
.sf-news-item h5 { font-size: 13px; font-weight: 600; line-height: 1.3; }
.sf-news-item h5:hover { text-decoration: underline; }
.sf-news-item p { font-size: 12px; color: var(--df-muted); margin-top: 2px; }

.sf-ad-card {
  background: var(--df-card);
  border-radius: 8px;
  border: 1px solid var(--df-border);
  overflow: hidden;
}
.sf-ad-img {
  width: 100%;
  height: 80px;
  background: linear-gradient(135deg, #0a66c2, #0d8ecf);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
}
.sf-ad-body { padding: 12px 16px; }
.sf-ad-body h5 { font-size: 13px; font-weight: 600; margin-bottom: 4px; }
.sf-ad-body p { font-size: 12px; color: var(--df-muted); margin-bottom: 8px; }
.sf-ad-btn {
  display: block;
  text-align: center;
  border: 1px solid var(--df-muted);
  border-radius: 4px;
  padding: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--df-muted);
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.15s, color 0.15s;
}
.sf-ad-btn:hover { border-color: var(--df-text); color: var(--df-text); }

.sf-footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  padding: 8px 0;
}
.sf-footer-links a { font-size: 11px; color: var(--df-muted); text-decoration: none; }
.sf-footer-links a:hover { text-decoration: underline; color: var(--df-blue); }
.sf-footer-brand { font-size: 11px; color: var(--df-muted); margin-top: 4px; }

/* Gradient avatars */
.av1  { background: linear-gradient(135deg, #667eea, #764ba2); }
.av2  { background: linear-gradient(135deg, #f093fb, #f5576c); }
.av3  { background: linear-gradient(135deg, #4facfe, #00f2fe); }
.av4  { background: linear-gradient(135deg, #43e97b, #38f9d7); }
.av5  { background: linear-gradient(135deg, #fa709a, #fee140); }
.av6  { background: linear-gradient(135deg, #a18cd1, #fbc2eb); }
.av7  { background: linear-gradient(135deg, #ffecd2, #fcb69f); color: #c7522a !important; }

/* Post image placeholders with gradients */
.post-img-1 { background: linear-gradient(135deg, #0a66c2 0%, #00c6fb 100%); }
.post-img-2 { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.post-img-3 { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }

/* Responsive */
@media (max-width: 1000px) {
  .sf-layout { grid-template-columns: var(--df-sidebar-width) 1fr; }
  .sf-right { display: none; }
}
@media (max-width: 700px) {
  .sf-layout { grid-template-columns: 1fr; }
  .sf-sidebar { display: none; }
}

/* Smooth animations */
.sf-post { animation: fadeUp 0.3s ease both; }
.sf-post:nth-child(2) { animation-delay: 0.05s; }
.sf-post:nth-child(3) { animation-delay: 0.1s; }
.sf-post:nth-child(4) { animation-delay: 0.15s; }
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Hover lift on cards */
.sf-post:hover { box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
</style>
